/*global require, define */
/**
 * Secondary js loader
 * Will add all necessary js libraries and common js setup functions necessary to render page frontend modules
 * It's loaded after main.js
 */
require(
	[
		'ModuleManager',
		'BackboneBase',
		'setupRivets',
		'componentPostLoader',
		'imagePostLoader',
		'jqueryVersionAdapter',
		'Core/appRequest'
	],
	function (ModuleManager, BackboneBase, Rivets, ComponentPostLoader, ImagePostLoader, JqueryVersionAdapter, AppRequest) {
		'use strict';

		ModuleManager.init();
		ComponentPostLoader.init();
		ImagePostLoader.init();
		JqueryVersionAdapter.run();
		AppRequest.run();

	}
);
define("mainPostload", function(){});

